import styled from "styled-components";

export const Container = styled.label`
  width: 100%;
  height: 55.17px;

  display: flex;

  overflow: hidden;
  border-radius: 19px;
  border: 0;
  outline: none;
  background-color: #fff;
  cursor: text;
`

export const IconContainer = styled.div`
  flex: 1.8;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  >svg{
    width: auto;
    max-width: 45%;
    height: 50%;
  }
`

export const Input = styled.input`
  flex: 8.2;
  height: 100%;
  padding: 0 5px;

  color: var(--blue00);
  font-size: 0.9375rem;
  font-weight: lighter;
  border: 0;
  outline: none;

  &::placeholder {
    color: var(--grayad);
  }
`
